import { render, staticRenderFns } from "./Refer.vue?vue&type=template&id=f2f1513c&scoped=true&"
import script from "./Refer.vue?vue&type=script&lang=js&"
export * from "./Refer.vue?vue&type=script&lang=js&"
import style0 from "./Refer.vue?vue&type=style&index=0&id=f2f1513c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f1513c",
  null
  
)

export default component.exports